<template>
    <div>
        <template v-for="(note, index) in notes">
            <p :key="index" v-html="note.note"></p>
        </template>
    </div>
</template>
<script>
export default {
    name: "rental-employment-notes",
    components: {},
    props: {
        notes: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    updated() {},
    detroyed() {},
    methods: {},
};
</script>

<style scoped>
</style>